import { usePositioningProps } from "@/ui/hooks/usePositioningProps"
import { classNames, ResponsiveStringValue } from "@punks/ui-core"

export interface PlaceableBlockProps {
  children?: any
  objectPosition?: ResponsiveStringValue
  position?: ResponsiveStringValue
  size?: ResponsiveStringValue
  className?: string
}

const PlaceableBlock = ({
  children,
  objectPosition,
  position,
  size,
  className,
}: PlaceableBlockProps) => {
  const props = usePositioningProps({ position, size, objectPosition })
  return (
    <div style={props.styles} className={classNames(props.classes, className)}>
      {children}
    </div>
  )
}

export default PlaceableBlock
